import { oauthConfig } from "../OauthConfig"
import { SalesReportDataOrigin } from "../SalesReport"
import { AuthAxios } from "./AuthAxios"
import { ProductsByFamilyTimelineResponse, SalesByIntervalResponse, ProductsReportResponse, SalesByClientTypesResponse, SalesByClientsResponse } from "../responses"
import { DateTime } from "luxon"
import { TimeAggregation, AggregationType } from "@/types/customCharts"

const baseUrl = `${oauthConfig.authority}/api/v1/sales/`

interface fetchSalesByIntervalQuery {
    from: string;
    to: string;
    interval: TimeAggregation;
    origin: SalesReportDataOrigin;
    deposit: boolean;
    multiplier: number;
    center: number;
    aggregation?: AggregationType;
    prevFrom?: string | null;
    prevTo?: string | null;
}

interface fetchProductsReportQuery {
    from: string;
    to: string;
    interval: TimeAggregation;
    origin: SalesReportDataOrigin;
    deposit: boolean;
    multiplier: number;
    center: number;
    aggregation?: AggregationType;
    prevFrom?: string | null;
    prevTo?: string | null;
}

export const SalesApi = {
    /**
     * Get sales from the API
     * 
     * @param start First date to get sales from
     * @param end Last date to get sales from
     * @returns 
     */
    fetchSalesByInterval: async (
        start: DateTime, end: DateTime,
        interval: TimeAggregation, origin: SalesReportDataOrigin, deposit: boolean, centerId: number,
        prevStart?: DateTime, prevEnd?: DateTime, aggregation?: AggregationType): Promise<SalesByIntervalResponse> => {
        // if (!end) { end =  }
        if (!interval) { interval = "month" }
        if (!origin) { origin = "all" }
        if (deposit === undefined) { deposit = false }
        const params: fetchSalesByIntervalQuery = {
            from: start.toRFC2822()!,
            to: end?.toRFC2822()!,
            interval: interval,
            origin: origin,
            deposit: deposit,
            multiplier: 1,
            center: centerId,
            ...(aggregation && { aggregation })
        }

        if (prevStart) {
            params.prevFrom = prevStart.toRFC2822()
            params.prevTo = prevEnd?.toRFC2822()
        }


        return await AuthAxios.get(`${baseUrl}byinterval`, { params })
            .then(resp => resp.data)
    },

    fetchProductsReport: async (start: DateTime, end: DateTime,
        interval: TimeAggregation, origin: SalesReportDataOrigin, deposit: boolean, centerId: number,
        prevStart?: DateTime, prevEnd?: DateTime, aggregation?: AggregationType): Promise<ProductsReportResponse> => {
        if (!interval) { interval = "month" }
        if (!origin) { origin = "all" }
        if (deposit === undefined) { deposit = false }
        const params: fetchProductsReportQuery = {
            from: start.toRFC2822()!,
            to: end?.toRFC2822()!,
            interval: interval,
            origin: origin,
            deposit: deposit,
            multiplier: 1,
            center: centerId,
            ...(aggregation && { aggregation })
        }

        if (prevStart) {
            params.prevFrom = prevStart.toRFC2822()
            params.prevTo = prevEnd?.toRFC2822()
        }

        return await AuthAxios.get(`${oauthConfig.authority}/api/v1/centers/${centerId}/reports/products`, { params })
            .then(resp => resp.data)
    },


    fetchSalesByClientTypes: async (
        start: DateTime, end: DateTime,
        interval: TimeAggregation, origin: SalesReportDataOrigin, deposit: boolean, centerId: number,
        prevStart?: DateTime, prevEnd?: DateTime, aggregation?: AggregationType): Promise<SalesByClientTypesResponse> => {
        if (!interval) { interval = "month" }
        if (!origin) { origin = "all" }
        if (deposit === undefined) { deposit = false }
        const params: fetchSalesByIntervalQuery = {
            from: start.toRFC2822()!,
            to: end?.toRFC2822()!,
            interval: interval,
            origin: origin,
            deposit: deposit,
            multiplier: 1,
            center: centerId,
            ...(aggregation && { aggregation })
        }

        if (prevStart) {
            params.prevFrom = prevStart.toRFC2822()
            params.prevTo = prevEnd?.toRFC2822()
        }

        return await AuthAxios.get(`${baseUrl}byclienttypes`, { params })
            .then(resp => resp.data)
    },

    // fetchSalesByClientType: async (start: Date, end?: Date, interval?: CumulInterval, multiplier?: number) => {
    //     if (!end) { end = dateUtils.createUTCDate() }
    //     if (!interval) { interval = "month" }
    //     if (!multiplier) { multiplier = 1 }

    //     const params = {
    //         from: start.toISOString(),
    //         to: end.toISOString(),
    //         interval: interval,
    //         multiplier: multiplier
    //     }

    //     return await AuthAxios.get("sales/clienttypes", { params })
    // },

    // /**
    //  * 
    //  * @param start Datetime to start fetching sales
    //  * @param end Datetime to end fetching sales
    //  * @param interval Range of time to fetch sales from day, week, month, year
    //  * @param multiplier Number of interval to fetch sales from 
    //  * @returns 
    //  */
    // fetchSalesCumulated: async (start: Date, end?: Date, interval?: CumulInterval, multiplier?: number) => {
    //     if (!end) {
    //         end = new Date()
    //     }

    //     if (!interval) {
    //         interval = "day"
    //     }

    //     const params = {
    //         from: start.toISOString(),
    //         to: end.toISOString(),
    //         interval: interval,
    //         multiplier: multiplier
    //     }

    //     return await AuthAxios.get("sales/cumulative", { params })
    // },

    // fetchSalesByFamily: async (start: Date, end?: Date) => {
    //     if (!end) {
    //         end = new Date()
    //         end.setHours(end.getHours() + 4)
    //     }

    //     const params = {
    //         action: "salesByFamilly",
    //         from: start.toISOString(),
    //         to: end.toISOString()
    //     }

    //     return await AuthAxios.get("", { params })
    // },

    // fetchSalesByFamilies: async (start: Date, end: Date) => {
    //     const params = {
    //         from: start.toISOString(),
    //         to: end.toISOString()
    //     }

    //     return await AuthAxios.get("sales/byfamilies", { params })
    // },

    // fetchProductsForFamily: async (centerId: number, reportId: string, familyName: string): Promise<ProductsByFamilyResponse> => {
    //     return await AuthAxios.get(`${oauthConfig.authority}/api/center/${centerId}/report/${reportId}/family/${encodeURIComponent(familyName)}/products`)
    //         .then(resp => resp.data as ProductsByFamilyResponse)
    //         .catch(err => err)
    // },

    fetchSalesByClients: async (
        start: DateTime, end: DateTime,
        interval: TimeAggregation, origin: SalesReportDataOrigin, deposit: boolean, centerId: number,
        prevStart?: DateTime, prevEnd?: DateTime): Promise<SalesByClientsResponse> => {
        if (!interval) { interval = "month" }
        if (!origin) { origin = "all" }
        if (deposit === undefined) { deposit = false }
        const params: Omit<fetchSalesByIntervalQuery, 'aggregation'> = {
            from: start.toRFC2822()!,
            to: end?.toRFC2822()!,
            interval: interval,
            origin: origin,
            deposit: deposit,
            multiplier: 1,
            center: centerId,
        }

        if (prevStart) {
            params.prevFrom = prevStart.toRFC2822()
            params.prevTo = prevEnd?.toRFC2822()
        }

        return await AuthAxios.get(`${baseUrl}byclients`, { params })
            .then(resp => resp.data)
    },

    fetchProductsTimelineForFamily: async (centerId: number, reportId: string, familyName: string): Promise<ProductsByFamilyTimelineResponse> => {
        return await AuthAxios.get(`${oauthConfig.authority}/api/center/${centerId}/report/${reportId}/family/${encodeURIComponent(familyName)}/products/timeline`)
            .then(resp => resp.data as ProductsByFamilyTimelineResponse)
    }
}